import MatchingAttributePicker from './MatchingAttributePicker';

export default MatchingAttributePicker;
